// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import INITIAL_STATE from '../orderCreation/initialState.json';

export type ServiceRequestDataType = Readonly<typeof INITIAL_STATE>;

export function saveZipCodeDataReducer(
    state: any,
    { payload }: any
): ServiceRequestDataType {
    if (payload) {
        return {
            ...state,
            zipCode: payload.zipCode,
            isValid: true,
        };
    }

    return INITIAL_STATE;
}

export function _getZipCodeDataFail(state: any) {
    return { ...state, isValid: false };
}
